(function () {
  'use strict';

  function initAutocomplete(input, container) {
    if (input.dataset.autocompleteInit === '1') return;
    input.dataset.autocompleteInit = '1';

    let dropdown = container.querySelector('.autocomplete-dropdown');
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'autocomplete-dropdown';
      container.appendChild(dropdown);
    }

    let service, placesService;
    let currentTimeout = null;
    let selectedIndex = -1;
    let servicesReady = false;

    const options = {
      componentRestrictions: { country: 'ch' },
      types: ['(regions)'],
      fields: ['address_components', 'formatted_address', 'geometry', 'name'],
    };

    function ensureServices() {
      if (servicesReady) return Promise.resolve();
      return window.loadGoogleMaps().then(function () {
        if (servicesReady) return;
        service = new google.maps.places.AutocompleteService();
        placesService = new google.maps.places.PlacesService(document.createElement('div'));
        servicesReady = true;
      });
    }

    function clearDropdown() {
      dropdown.innerHTML = '';
      dropdown.classList.remove('active');
      selectedIndex = -1;
    }

    function selectPlace(prediction) {
      placesService.getDetails({
        placeId: prediction.place_id,
        fields: ['formatted_address', 'geometry', 'name', 'address_components']
      }, function (place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          const fullAddress = prediction.structured_formatting.main_text + ', ' + (prediction.structured_formatting.secondary_text || '');
          input.value = fullAddress;
          sessionStorage.setItem('destination', fullAddress);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          clearDropdown();
        }
      });
    }

    function createPlaceElement(prediction, index) {
      const div = document.createElement('div');
      div.className = 'autocomplete-item';
      div.setAttribute('data-index', index);
      div.innerHTML =
        '<span class="place-main-text">' + prediction.structured_formatting.main_text + '</span>' +
        '<div class="place-secondary-text">' + (prediction.structured_formatting.secondary_text || '') + '</div>';
      div.addEventListener('click', function () { selectPlace(prediction); });
      return div;
    }

    function updateDropdown(predictions) {
      clearDropdown();
      if (predictions && predictions.length > 0) {
        predictions.forEach(function (p, i) { dropdown.appendChild(createPlaceElement(p, i)); });
        dropdown.classList.add('active');
      }
    }

    function runQuery(query) {
      ensureServices().then(function () {
        service.getPlacePredictions(Object.assign({ input: query }, options), function (predictions, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
            updateDropdown(predictions);
          }
        });
      }).catch(function (err) { console.error(err); });
    }

    input.addEventListener('focus', ensureServices, { once: true });
    input.addEventListener('pointerdown', ensureServices, { once: true });

    input.addEventListener('input', function (e) {
      const query = e.target.value;
      if (currentTimeout) clearTimeout(currentTimeout);
      if (query.length < 2) { clearDropdown(); return; }
      currentTimeout = setTimeout(function () { runQuery(query); }, 300);
    });

    input.addEventListener('keydown', function (e) {
      const items = dropdown.getElementsByClassName('autocomplete-item');
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          selectedIndex = Math.max(selectedIndex - 1, -1);
          break;
        case 'Enter':
          e.preventDefault();
          if (selectedIndex >= 0 && items[selectedIndex]) items[selectedIndex].click();
          break;
        case 'Escape':
          clearDropdown();
          break;
      }
      Array.from(items).forEach(function (item, index) {
        item.style.backgroundColor = index === selectedIndex ? '#e9ecef' : '';
      });
    });

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) clearDropdown();
    });
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.autocomplete-input').forEach(function (container) {
      const input = container.querySelector('#address-autocomplete');
      if (input) initAutocomplete(input, container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
